import { AgentIcon, FactionType } from "~/business";
import { Colors } from "~/jsx/theme";
import { expectNever, parseEnumOrError } from "~/utils";

export const getActionSlotColor = (agentIcon: AgentIcon): string => {
  switch (agentIcon) {
    case AgentIcon.SpiceTrade:
    case AgentIcon.City:
    case AgentIcon.Landsraad:
      return Colors.agentIcon[agentIcon].main;
    case AgentIcon.Emperor:
    case AgentIcon.SpacingGuild:
    case AgentIcon.BeneGesserit:
    case AgentIcon.Fremen:
      return Colors.faction[
        parseEnumOrError<FactionType>(FactionType, agentIcon)
      ].light;
    default:
      expectNever(agentIcon);
      throw new Error();
  }
};
